import { Stack, Text } from '@chakra-ui/react'
import type { ReactElement } from 'react'

import type { SeriesPagePendingCohost } from '@/common/services/seriesPage/types'

import { getUserUrl } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'
import UserAvatar from '@/components/UserAvatar'

export default function CohostReviewTableAvatar({
  user,
}: {
  user: SeriesPagePendingCohost
}): ReactElement {
  const userId = user.userId
  const userName = user.displayName
  const avatarUrl = user.avatarUrl ?? ''
  const cohostProgressionLevel = user.progressionLevel
  const username = user.username

  return (
    <ShwLink href={getUserUrl({ userId, username })}>
      <Stack
        direction="row"
        align="center"
        p="8px"
        borderRadius="8px"
        _hover={{ backgroundColor: 'bg.muted' }}
        cursor="pointer"
      >
        <UserAvatar
          src={`${avatarUrl}`}
          size="md"
          name={userName}
          progressionLevel={cohostProgressionLevel}
        />
        <Text fontWeight="bold">{userName}</Text>
      </Stack>
    </ShwLink>
  )
}
